import { configureStore } from '@reduxjs/toolkit';
import cartreducer from "./features/cartSlice";
import cartListreducer from "./features/cartItemSlice";
const store = configureStore({
    reducer:{
        cartitems: cartreducer,
        cartListslice : cartListreducer,
    }
});

export default store;